import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Loading } from 'src/shared/components/loading/loading';
import { Util } from 'src/shared/util/util';
import { WindowService } from 'src/shared/providers/window.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PaymentMethodsProvider } from 'src/providers/payment-methods/payment-methods.provider';

@Component({
    templateUrl: 'validate-bank-account.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ValidateBankAccountPage implements OnInit {
  backPage: string;
  dialogParams: any;
  errorMessage: String;
  teamId: any;
  isRightSideContent = true;
  amountOrCodeItems: any[] = [
    { viewValue: 'Amount', value: 'amount' },
    { viewValue: 'Code', value: 'code' },
  ];
  form = new FormGroup({
    amountOrCode: new FormControl('amount'),
    value1: new FormControl('', Validators.required),
    value2: new FormControl('', Validators.required),
  });

  
  boundValidateBankAccount = this.validateBankAccount.bind(this);

constructor(
    private navCtrl: CustomNavController,
    private util: Util,
    private windowService: WindowService,
    private rightSidePanelService: RightSidePanelService,
    private paymentMethodsProvider: PaymentMethodsProvider,
    private storage: TidyStorage
  ) {}

  @Loading('', true)
  async ngOnInit(): Promise<void> {
    try {
      this.isRightSideContent =
        (await this.storage.retrieve('dialog-right-side-open')) || false;
      this.dialogParams = await this.storage.retrieve('dialog-params');
      this.backPage =
        this.navCtrl.getParam('backPage') ||
        this.dialogParams?.backPage ||
        'more';
      this.rightSidePanelService.setDialogPageTitle('Validate Bank Account');
    } catch (err) {
      this.errorMessage =
        err.error && err.error.message ? err.error.message : err.message;
    }
  }

  navBack(): void {
    const isDesktopRes = this.windowService.isDesktopRes;
    if (isDesktopRes) {
      this.rightSidePanelService.goBack();
    } else {
      this.navCtrl.navigateRoot('payment-methods');
    }
  }

  selectAmountOrCode(event: {
    viewValue: string;
    value: 'amount' | 'code';
  }): void {
    this.form.controls.value1.setValue('');
    this.form.controls.value2.setValue('');
    if (event.value === 'amount') {
      this.form.controls.value2.setValidators([Validators.required]);
    } else {
      this.form.controls.value2.setValidators([Validators.nullValidator]);
    }
    this.form.controls.value1.updateValueAndValidity();
    this.form.controls.value2.updateValueAndValidity();
  }

  async validateBankAccount(): Promise<void> {
    try {
      const { amountOrCode, value1, value2 } = this.form.value;
      const payload: any = {};

      if (amountOrCode === 'code') {
        if (!value1.startsWith('SM')) {
          throw new Error('Code must start with SM');
        }
        payload.code = value1;
      } else {
        const amount1 = Number(value1.replace('$', ''));
        const amount2 = Number(value2.replace('$', ''));

        if (amount1 >= 1 || amount2 >= 1) {
          throw new Error('Amounts must be in cents (e.g., $0.20)');
        }

        payload.amounts = [this.parseAmount(value1), this.parseAmount(value2)];
      }

      const bankAccount = await this.paymentMethodsProvider.validateMicroDeposit(
        this.dialogParams.paymentMethod.id,
        payload
      );
      if (bankAccount?.status === 'inactivated') {
        this.util.showError('Error validating bank account, please update your bank information.');
      } else {
        this.util.showSuccess('Bank account validated successfully.');
      }
      this.navBack();
    } catch (err) {
      this.util.showError(`Error validating bank account. ${  err.message}`);
    }
  }

  parseAmount(amount: string): number {
    amount = amount.replace('$', '');
    return Number(amount) * 100;
  }
}
